import { render, staticRenderFns } from "./p-packages-edit-audience-popup.vue?vue&type=template&id=1b8809fe&scoped=true"
import script from "./p-packages-edit-audience-popup.vue?vue&type=script&lang=js"
export * from "./p-packages-edit-audience-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8809fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b8809fe')) {
      api.createRecord('1b8809fe', component.options)
    } else {
      api.reload('1b8809fe', component.options)
    }
    module.hot.accept("./p-packages-edit-audience-popup.vue?vue&type=template&id=1b8809fe&scoped=true", function () {
      api.rerender('1b8809fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mpackages/views/popups/p-packages-edit-audience-popup/p-packages-edit-audience-popup.vue"
export default component.exports